import { Component, OnInit, EventEmitter, Input, Output  } from '@angular/core';
import {Equipment} from '../equipment';

@Component({
  selector: 'app-equipment-list',
  templateUrl: './equipment-list.component.html',
  styleUrls: ['./equipment-list.component.css']
})
export class EquipmentListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() list: Equipment[];
  @Input() selectedEquip :Equipment;
  @Output() selectEquipChange = new EventEmitter<number>();
  @Output() removeEquip = new EventEmitter<number>();
  @Output() editEquip = new EventEmitter<number>();
  
  select(i):void {
	this.selectEquipChange.emit(i);
  }
  
  remove(i):void {
	this.removeEquip.emit(i);
  }
  
  edit(i):void {
	this.editEquip.emit(i);
  }
  
  sortLvl():void {
	this.list.sort((a,b) => this.getNumber(a.level,a.enhancementLvl)<this.getNumber(b.level,b.enhancementLvl)?1:-1);
  }
  
  getNumber(i,j):number{
	if (Number(j) < 10) {
		return Number(i + "0" + j);
	}
	
	return Number(i + j);
  }
}
